export default __webpack_public_path__ + "static/media/solucao-01.40bddb28.webp";